/*🌟 GLOBAL COMPONENTS BARREL 🌟*/

// ==========================================
// 1. COMMON COMPONENTS
// ==========================================
//-------- Navigation ---------
export { default as DesktopNav } from "./common/navigation/DesktopNav";
export { default as Logo } from "./common/navigation/Logo";
export { default as MobileNav } from "./common/navigation/MobileNav";
export { default as NavMenuItem } from "./common/navigation/NavMenuItem";
export { default as ServicesMegaMenu } from "./common/navigation/ServicesMegaMenu";
export { default as AnimatedHamburger } from "./common/navigation/AnimatedHamburger";
export { default as NavigationOverlay } from "./common/navigation/NavigationOverlay";
export { default as SecondaryNavSection } from "./common/navigation/SecondaryNavSection";
export { default as FloatingActions } from "./common/navigation/FloatingActions";

//-------- Titles ---------
export { default as SectionSubHeading } from "./common/titles/SectionSubHeading";
export { default as SectionTitle } from "./common/titles/SectionTitle";
export { default as TitleOverlay } from "./common/titles/TitleOverlay";
export { default as Heading } from "./common/titles/Heading";

//-------- Forms ---------
export { default as CommonInput } from "./common/inputs/CommonInput";
export { default as CommonTextarea } from "./common/inputs/CommonTextarea";

//-------- Cursor ---------
export { default as HeroCursor } from "./common/cursor/HeroCursor";

//-------- wrapper ---------
export { default as Container } from "./wrapper/Container";

//-------- utils function ---------
export { default as SplitText } from "./common/titles/SplitText";

//-------- Cards---------
export { default as TestimonialCard } from "./common/cards/TestimonialCard";
export { default as ServicesCard } from "./common/cards/ServicesCard";
export { default as CaseStudyCard } from "./common/cards/CaseStudyCard";
export { default as LegalCard } from "./common/cards/LegalCard";
export { default as ProcessCard } from "./common/cards/ProcessCard";
export { default as CareerGalleryCard } from "./common/cards/CareerGalleryCard";
export { default as TeamCard } from "./common/cards/TeamCard";
export { default as TeamInfoCard } from "./common/cards/TeamInfoCard";
export { default as TeamOutroCard } from "./common/cards/TeamOutroCard";
export { default as InfoTileCard } from "./common/cards/InfoTileCard";
export { default as BookingSuccessCard } from "./common/cards/BookingSuccessCard";
export { default as BookingEmbedCard } from "./common/cards/BookingEmbedCard";
export { default as HouseRuleRow } from "./common/cards/HouseRuleRow";
export { default as RulePreviewCard } from "./common/cards/RulePreviewCard";
export { default as CapabilityCardVisual } from "./common/cards/CapabilityCardVisual";
export { default as ServiceDeckCard } from "./common/cards/ServiceDeckCard";
export { default as SelectedWorkCard } from "./common/cards/SelectedWorkCard";

//-------- Loaders ---------
export { default as BrandLoader } from "./common/loaders/BrandLoader";

//-------- Indicators ---------
export { default as TeamProgress } from "./common/indicators/TeamProgress";
export { default as CountUpValue } from "./common/indicators/CountUpValue";

// ==========================================
// 2. GLOBAL COMPONENTS
// ==========================================
export { default as NavMenu } from "./global/NavMenu";

// ==========================================
// 3. SHARED COMPONENTS
// ==========================================
export { default as AppButton } from "./shared/AppButton";
export { default as ActionCircleButton } from "./shared/ActionCircleButton";
export { default as Footer } from "./shared/Footer";
export { default as Contact } from "./shared/Contact";
export { default as Testimonials } from "./shared/Testimonials";
export { default as Header } from "./shared/Header";
export { default as ClosingBlock } from "./shared/ClosingBlock";
export { default as MeetOurTeam } from "./shared/MeetOurTeam";
export { default as HouseRules } from "./shared/HouseRules";
export { default as BookSession } from "./shared/BookSession";

// ==========================================
// 4. ANIMATED COMPONENTS
// ==========================================
export { default as InfiniteMarquee } from "./animations/InfiniteMarquee";
export { default as CaseStudyImageHover } from "./animations/CaseStudyImageHover";
export { default as SpinningBadge } from "./animations/SpinningBadge";
export { default as TextMarquee } from "./animations/TextMarquee";
// ScrollExpandVideo (gsap MorphSVGPlugin) and CurvedSlider (swiper) are
// deliberately NOT re-exported here. This barrel is imported by nearly every
// client component, and a barrel pulls its whole module graph: re-exporting
// them put swiper and MorphSVG in the shared first-load chunk of every route,
// including the ones that render neither. Import them from their own path.
export { default as ScrollStack } from "./animations/ScrollStack";
export { default as VelocityMarquee } from "./animations/VelocityMarquee";

// ==========================================
// 4. SKELETON COMPONENTS
// ==========================================
